import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export interface ToastInfo {
    header?: string;
    body: string;
    delay?: number;
    class?: string;
}

/** A service to handle the adding and removing of toast notifications */
@Injectable({ providedIn: 'root' })
export class ToastService {
    toasts: ToastInfo[] = [];

    constructor(public translate: TranslateService)
    {

    }

    /** Shows a generic toast */
    show(body: string, header?: string, classname?: string) {
        this.toasts.push({ header, body, class: classname });
    }

    /** Shows a sucess toast */
    showSuccess(body: string, header?: string) {
        this.show(body, header, "text-bg-success");
    }

    /** Shows an error toast */
    showError(body: string, header?: string) {
        this.show(body, header, "text-bg-danger");
    }

    /** Shows a warning toast */
    showWarning(body: string, header?: string) {
        this.show(body, header, "text-bg-warning");
    }



    /** Shows a generic toast translated from a key  */
    showTranslated(key: string, header?: string, classname?: string) {
        this.translate.get(key).subscribe({
            next: value => { this.show(value, header, classname); },
            error: e => { console.error(e); } 
        });
    }

    /** Shows a success toast translated from a key */
    showSuccessTranslated(key: string, header?: string) {
        this.showTranslated(key, header, "text-bg-success" );
    }

    /** Shows an error toast translated from a key */
    showErrorTranslated(key: string, header?: string) {
        this.showTranslated(key, header, "text-bg-danger" );
    }

    /** Shows a warning toast translated from a key */
    showWarningTranslated(key: string, header?: string) {
        this.showTranslated(key, header, "text-bg-warning" );
    }



    /** Removes a toast from the array */
    remove(toast: ToastInfo) {
        this.toasts = this.toasts.filter(t => t != toast);
    }

    clear() {
        this.toasts = [];
    }
}